export const LogoWide = ({ className = "" }) => (
  <img src={`${process.env.PUBLIC_URL}/img/logo-wide.webp`} alt="JL Nexus Soluções Digitais" className={`brightness-125 ${className}`} draggable="false" />
);

export const LogoSquare = ({ className = "", alt = "Logotipo oficial JL Nexus Soluções Digitais" }) => (
  <img src={`${process.env.PUBLIC_URL}/img/logo-square.webp`} alt={alt} className={className} draggable="false" />
);

export const Wordmark = ({ className = "" }) => (
  <span className={`inline-flex items-center ${className}`}>
    <LogoWide className="h-11 w-auto drop-shadow-[0_0_14px_rgba(8,123,255,0.35)]" />
  </span>
);
